module.exports = __webpack_public_path__ + "img/ide-physical.c0f6144d.svg";